import { Table } from 'antd';
import React, { useState, useEffect } from 'react'
import { Tooltip } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';


const DomesticConsolSea = () => {
    useEffect(() => {
        // Bootstrap's initialization (if needed manually)
        const bootstrap = require("bootstrap/dist/js/bootstrap.bundle.min.js");
    }, []);

    

    const navigate = useNavigate();

    const organisationOptions = [
        { value: 1, label: "Organisation 1" },
        { value: 2, label: "Organisation 2" },
        { value: 3, label: "Organisation 3" },
        { value: 4, label: "Organisation 4" },
        { value: 5, label: "Organisation 5" },
    ];

    const portOptions = [
        { value: 1, label: "Port 1" },
        { value: 2, label: "Port 2" },
        { value: 3, label: "Port 3" },
        { value: 4, label: "Port 4" },
        { value: 5, label: "Port 5" },
    ]

    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "OL", dataIndex: "ol", key: "ol" },
        { title: "FL", dataIndex: "fl", key: "fl" },
        { title: "E Docket", dataIndex: "edocket", key: "edocket" },
        { title: "Consol No", dataIndex: "consolno", key: "consolno" },
        // { title: "Tracking No", dataIndex: "trackingno", key: "trackingno" },
        { title: "Date", dataIndex: "date", key: "date" },
        { title: "Consol Type", dataIndex: "consoltype", key: "consoltype" },
        { title: "Cargo Type", dataIndex: "cargotype", key: "cargotype" },
        { title: "Status", dataIndex: "status", key: "status" },
        { title: "Loading port", dataIndex: "loadingport", key: "loadingport" },
        { title: "Place of Discharge", dataIndex: "placeofdischarge", key: "placeofdischarge" },
        // { title: "Master Notify", dataIndex: "Masternotify", key: "Masternotify" },
        { title: "Loading Port", dataIndex: "loadingport", key: "loadingport" },
        { title: "Place of Discharge", dataIndex: "placeofdischarge", key: "placeofdischarge" },
        { title: "Shipping Line", dataIndex: "airline", key: "airline" },
        { title: "BL Number", dataIndex: "awbno", key: "awbno" },
        { title: "BL Issue by", dataIndex: "awbissuedby", key: "awbissuedby" },
        { title: "Port Cut Off", dataIndex: "active", key: "active" },
        { title: "CFS Cut Off", dataIndex: "coloadagent", key: "coloadagent" },
        { title: "CFS Open", dataIndex: "awbedistatus", key: "awbedistatus" },
        { title: "CFS Close", dataIndex: "action", key: "action" },
        { title: "Vessel Open", dataIndex: "action", key: "action" },
        { title: "Vessel Close", dataIndex: "action", key: "action" },
        { title: "SI CutOff", dataIndex: "action", key: "action" },
        { title: "DOC Cut Off", dataIndex: "action", key: "action" },
        { title: "Cargo Cut Off", dataIndex: "action", key: "action" },
        { title: "Port Open", dataIndex: "action", key: "action" },
        { title: "Active", dataIndex: "action", key: "action" },
        { title: "Co-Load Agent", dataIndex: "action", key: "action" },
    ];

    const dataSource = [
        {
            key: "1",
        }
    ];
    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            Domestic Sea Consol<span className="count-title">3</span>
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                        </div>
                    </div>
                    <div className="card">

                        <div className="card-body">

                            {/* Filter */}
                            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    <div className="dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            className="dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                        >
                                            <i className="ti ti-sort-ascending-2 me-2" />
                                            Sort{" "}
                                        </a>

                                        <div className="dropdown-menu  dropdown-menu-start">
                                            <ul>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Ascending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Descending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Viewed
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Added
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="icon-form mb-3 mb-sm-0">
                                        <span className="form-icon">
                                            <i className="ti ti-search" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Search "
                                            name='search_by'
                                        // value={searchText}
                                        // onChange={(e) => setSearchText(e.target.value)}
                                        />
                                    </div>
                                    <div className="dropdown form-sorts ms-2">
            {/* Tooltip placement */}
            <a
                href="#"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                className="dropdown-toggle py-1"
                style={{
                    paddingTop: "7px",
                    paddingBottom: "6px"
                }}
            >
                <i className="ti ti-filter-share me-0" />
            </a>
            <div
                className="dropdown-menu filter-dropdown-menu p-3"
                style={{ zIndex: 9 }}
            >
               <div className="filter-set-view">
            <table className="content-table">
                <tbody>
                    <tr>
                        <td>
                            <label htmlFor="consolno.">Consol No.</label>
                        </td>
                        <td className="input_box_filter">
                            <input
                                type="text"
                                className="form-control form-control-sm ms-2"
                                placeholder="Enter Consol no."
                                name="consolno."
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label htmlFor="consolno.">Consol Date</label>
                        </td>
                        <td className="input_box_filter">
                            <input
                                type="date"
                                className="form-control form-control-sm ms-2"
                                placeholder="Enter Consol no."
                                name="consolno."
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label htmlFor="consoleType">Active</label>
                        </td>
                        <td className="input_box_filter">
                            <select
                                className="form-control form-control-sm ms-2"
                                id="consoleType"
                            >
                                <option value="ALL">Yes</option>
                                <option value="1">No</option>
                               
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label htmlFor="consoleType">Console Type</label>
                        </td>
                        <td className="input_box_filter">
                            <select
                                className="form-control form-control-sm ms-2"
                                id="consoleType"
                            >
                                <option value="ALL">All</option>
                                <option value="1">Direct</option>
                                <option value="2">Buyer Consol</option>
                                <option value="3">Agent Consol</option>
                                <option value="4">Back to Back</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label htmlFor="status">Status</label>
                        </td>
                        <td className="input_box_filter">
                            <select
                                className="form-control form-control-sm ms-2"
                                id="status"
                            >
                                <option value="all">All</option>
                                <option value="completed">Completed</option>
                                <option value="pending">Pending</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label htmlFor="shipper">Origin Agent</label>
                        </td>
                        <td className="input_box_filter">
                            <Select
                                id="shipper"
                                className="mt-2 custom-selector w-100"
                               
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label htmlFor="shipper">Destination Agent</label>
                        </td>
                        <td className="input_box_filter">
                            <Select
                                id="shipper"
                                className="mt-2 custom-selector w-100"
                               
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label htmlFor="loadPort">Load Port</label>
                        </td>
                        <td className="input_box_filter">
                            <Select
                                id="loadPort"
                                className="mt-2 custom-selector w-100"
                                options={portOptions}
                                name="loadPort"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label htmlFor="dischargePort">Discharge Port</label>
                        </td>
                        <td className="input_box_filter">
                            <Select
                                id="dischargePort"
                                className="mt-2 custom-selector w-100"
                                options={portOptions}
                                name="dischargePort"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className="filter-reset-btns mt-3">
                <div className="row">
                    <div className="col-6">
                        <button type="button" className="btn btn-light w-100">
                            Reset
                        </button>
                    </div>
                    <div className="col-6">
                        <button type="submit" className="btn btn-primary w-100">
                            Filter
                        </button>
                    </div>
                </div>
            </div>
        </div>
            </div>
        </div>

                                    {/* <div className="icon-form">
                                        <span className="form-icon">
                                            <i className="ti ti-calendar" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control bookingrange"
                                            placeholder=""
                                        />
                                    </div> */}
                                </div>
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    <Tooltip placement="top" title="Print Data">
                                        <div
                                            className="btn btn-primary cursor-pointer me-2"
                                        >
                                            <i className="ti ti-printer text-white"></i>
                                            {/* <ReactTooltip id="print" place="top" effect="solid" /> */}
                                        </div>
                                    </Tooltip>
                                    <Tooltip placement="top" title="Export Data">
                                        <div
                                            className="btn btn-primary cursor-pointer me-2"
                                        >
                                            <i className="fas fa-file-export text-white"></i>
                                            {/* <ReactTooltip id="export" place="top" effect="solid" /> */}
                                        </div>
                                    </Tooltip>
                                    <button type='submit' className="btn btn-primary me-2">
                                        Search
                                    </button>
                                    <a
                                        className='btn btn-light me-2'
                                    //   style={{ background: "#04aed2", marginTop: "7px", marginBottom: "15px" }}
                                    >
                                        Clear
                                    </a>
                                    <div className="dropdown">
                                    <div
                                        className="btn btn-primary cursor-pointer me-2"
                                        // onClick={handleAddShow}
                                        onClick={() => { navigate("#") }}
                                    >
                                        <i className="ti ti-square-rounded-plus me-2" />
                                        Add 
                                    </div>
  
</div>

                                    {/* <div className="dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            className="btn bg-soft-purple text-purple"
                                            data-bs-toggle="dropdown"
                                            data-bs-auto-close="outside"
                                        >
                                            <i className="ti ti-columns-3 me-2" />
                                            Manage Columns
                                        </a>
                                        <div className="dropdown-menu  dropdown-menu-md-end dropdown-md p-3">
                                            <h4 className="mb-2 fw-semibold">Want to manage datatables?</h4>
                                            <p className="mb-3">
                                                Please drag and drop your column to reorder your table and
                                                enable see option as you want.
                                            </p>
                                            <div className="border-top pt-3">
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Name
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-name" className="check" />
                                                        <label htmlFor="col-name" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Phone
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-phone" className="check" />
                                                        <label htmlFor="col-phone" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Email
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-email" className="check" />
                                                        <label htmlFor="col-email" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Tags
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-tag" className="check" />
                                                        <label htmlFor="col-tag" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Location
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-loc" className="check" />
                                                        <label htmlFor="col-loc" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Rating
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-rate" className="check" />
                                                        <label htmlFor="col-rate" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Owner
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-owner" className="check" />
                                                        <label htmlFor="col-owner" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Contact
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-contact"
                                                            className="check"
                                                            defaultChecked=""
                                                        />
                                                        <label htmlFor="col-contact" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Status
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-status"
                                                            className="check"
                                                        />
                                                        <label htmlFor="col-status" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Action
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-action"
                                                            className="check"
                                                        />
                                                        <label htmlFor="col-action" className="checktoggle" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                    {/* <div className="view-icons">
                                        <Link onClick={() => { setGrid(true) }} className={`${grid === true && "active"}`}>
                                            <i className="ti ti-list-tree" />
                                        </Link>
                                        <Link onClick={() => { setGrid(false) }} className={`${grid === false && "active"}`}>
                                            <i className="ti ti-grid-dots" />
                                        </Link>
                                    </div> */}
                                </div>
                            </div>
                            {/* /Filter */}
                          

                            <div className="table-responsive custom-table">
                                <Table className="table datanew dataTable no-footer" pagination={false}
                                    dataSource={dataSource} columns={columns} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DomesticConsolSea